
/* User defined models */
export class Program {
  id: string;
  code: string;
  uri: string;
  name: string;
  schedule?: any;
  testing?: any;
  authorization?: any;
  reminders?: any[];
  surveys?: any[];
  payment?: any;
  initial?: any;
  reschedule?: any;
  cancel?: any;
  types?: any[];
  countries?: any[];
  isCandidateCentric?: boolean;

  constructor(
    id: string,
    code: string,
    uri: string,
    name: string,
    schedule?: any,
    testing?: any,
    authorization?: any,
    reminders?: any[],
    surveys?: any[],
    payment?: any,
    initial?: any,
    reschedule?: any,
    cancel?: any,
    types?: any[],
    countries?: any[],
    isCandidateCentric?: boolean
  ) {
    this.id = id;
    this.code = code;
    this.uri = uri;
    this.name = name;
    this.schedule = schedule;
    this.testing = testing;
    this.authorization = authorization;
    this.reminders = reminders;
    this.surveys = surveys;
    this.payment = payment;
    this.initial = initial;
    this.reschedule = reschedule;
    this.cancel = cancel;
    this.types = types;
    this.countries = countries;
    this.isCandidateCentric = isCandidateCentric;
  }
}